import download from "downloadjs";
import { customFetch } from "./CustomFetch";
import { meUrl } from "./rtk/MeApi";

const getCandidateCourseUrl = (candidateCourseId: string) => `${meUrl}/candidateCourse/${candidateCourseId}`;

const getInternalCandidateCourseUrl = (candidateId: string, candidateCourseId: string) =>
  `candidate/${candidateId}/courses/${candidateCourseId}`;

const handleDownloadResponse = async (response: Response, fallbackFileName: string) => {
  const contentDispositionHeader = response.headers.get("content-disposition");
  const fileName =
    contentDispositionHeader !== null ? contentDispositionHeader.split(";")[1].split('"')[1] : fallbackFileName;
  if (response.ok) {
    var blob = await response.blob();
    download(blob, fileName);
  }
};

export const downloadCandidateCourseCertificate = async (candidateCourseId: string, fallbackFileName: string) => {
  const response = await customFetch(`${getCandidateCourseUrl(candidateCourseId)}/downloadCertificate`);
  await handleDownloadResponse(response, fallbackFileName);
};

export const downloadCandidateCoursePerformanceRecord = async (candidateCourseId: string, fallbackFileName: string) => {
  const response = await customFetch(`${getCandidateCourseUrl(candidateCourseId)}/downloadPerformanceRecord`);
  await handleDownloadResponse(response, fallbackFileName);
};

export const downloadInternalCandidateCourseCertificate = async (
  candidateId: string,
  candidateCourseId: string,
  fallbackFileName: string
) => {
  const response = await customFetch(
    `${getInternalCandidateCourseUrl(candidateId, candidateCourseId)}/downloadCertificate`
  );
  await handleDownloadResponse(response, fallbackFileName);
};

export const downloadInternalCandidateCoursePerformanceRecord = async (
  candidateId: string,
  candidateCourseId: string,
  fallbackFileName: string
) => {
  const response = await customFetch(
    `${getInternalCandidateCourseUrl(candidateId, candidateCourseId)}/downloadPerformanceRecord`
  );
  await handleDownloadResponse(response, fallbackFileName);
};
